(() => {
  const replaceStateSilently =
    window.Phenomena?.replaceStateSilently || window.history.replaceState.bind(window.history);

  const patchProductInfo = () => {
    const ProductInfo = customElements.get('product-info');

    if (!ProductInfo || ProductInfo.prototype.variantUrlFixApplied) return Boolean(ProductInfo);

    ProductInfo.prototype.updateURL = function (url, variantId) {
      const variantQuery = variantId ? `?variant=${variantId}` : '';
      const nextUrl = `${url}${variantQuery}`;

      this.shareButton?.updateUrl(`${window.theme.routes.shop_url}${nextUrl}`);

      if (this.dataset.updateUrl !== 'false') {
        replaceStateSilently({}, '', nextUrl);
      }
    };

    ProductInfo.prototype.variantUrlFixApplied = true;
    return true;
  };

  if (!patchProductInfo()) {
    customElements.whenDefined('product-info').then(patchProductInfo);
  }
})();
